var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75C18.45 8.75 21.25 11.55 21.25 15C21.25 15.8125 21.0875 16.575 20.8 17.2875L24.45 20.9375C26.3375 19.3625 27.825 17.325 28.7375 15C26.575 9.5125 21.2375 5.625 14.9875 5.625C13.2375 5.625 11.5625 5.9375 10.0125 6.5L12.7125 9.2C13.425 8.9125 14.1875 8.75 15 8.75ZM2.5 5.3375L5.35 8.1875L5.925 8.7625C3.85 10.375 2.225 12.525 1.25 15C3.4125 20.4875 8.75 24.375 15 24.375C16.9375 24.375 18.7875 24 20.475 23.325L21 23.85L24.6625 27.5L26.25 25.9125L4.0875 3.75L2.5 5.3375ZM9.4125 12.25L11.35 14.1875C11.2875 14.45 11.25 14.725 11.25 15C11.25 17.075 12.925 18.75 15 18.75C15.275 18.75 15.55 18.7125 15.8125 18.65L17.75 20.5875C16.9125 21 15.9875 21.25 15 21.25C11.55 21.25 8.75 18.45 8.75 15C8.75 14.0125 9 13.0875 9.4125 12.25ZM14.8 11.275L18.7375 15.2125L18.7625 15.0125C18.7625 12.9375 17.0875 11.2625 15.0125 11.2625L14.8 11.275Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEye);
export default __webpack_public_path__ + "static/media/ic_eye.ec3ed304cd4517628bdd495d4dabc2cd.svg";
export { ForwardRef as ReactComponent };